export default {
  'APP_SHPGRP_DLVRMTHD_UPDATE': 'CUST_DLVRMTHD_UPDATE',
  'APP_SHPGRP_DLVRADR_UPDATE': 'CUST_DLVRADR_UPDATE',
  'APP_SHPGRP_PCKUP_UPDATE': 'CUST_PCKUP_UPDATE',
  'APP_SHPGRP_CNCL': 'CUST_ALLOW_CNCL'
}